import { SettingLayout } from 'layouts/SettingLayout';
import React from 'react';
import { AiUserInnerOptions } from '../AiUserInnerOptions';
import { MainContainer } from 'components/shared';
import { Box } from 'components/ui/Box';
import { CreateForm } from './CreateForm';

export const CreateAiUser: React.FC = () => {
  const { options } = AiUserInnerOptions();
  return (
    <MainContainer>
      <SettingLayout options={options} page="ai-users">
        <Box>
          <CreateForm />
        </Box>
      </SettingLayout>
    </MainContainer>
  );
};
